/*
 * @Author: Gaho
 * @Date: 2024-02-27 10:41:29
 * @LastEditors: Gaho
 * @LastEditTime: 2024-05-17 15:59:49
 * @Description: 
 */
import { defineStore } from 'pinia';
import {getGameName } from '@/common/js/gameAbout';

export const useLoadingStore = defineStore('loading', {
    state: () => {
        return {
            showLoading: true, // 默认设为 ture，因为访问页面时“需要” 首先显示 loading 遮罩，
            gameLoading: import.meta.server && !!getGameName(), // 如果在访问游戏页，此处设为 true，即在服务端就把遮罩准备好，防止 hydration 报错
        };
    },
});

